import { CustomModal } from "../../../../../../../../../../components/ui/CustomModal/CustomModal";
import { useSetZIndex } from "../../../../../../../../../../hooks/useSetZIndex";
import { CustomInput } from "../../../../../../../../../../components/ui/CustomInput/CustomInput";
import { CustomSelect } from "../../../../../../../../../../components/ui/CustomSelect/CustomSelect";
import { Radio } from "../../../../../../../../../../components/ui/Radio/Radio";
import { IconSvg } from "../../../../../../../../../../utils/constants/icons/iconSvg.constant";
import { Button } from "../../../../../../../../../../components/ui/Buttons/Button/Button";
import "./NewListIpModal.scss";
import { classNames } from "../../../../../../../../../../utils/helpers/classNames";
import { useTranslation } from "../../../../../../../../../../hooks";

export const NewListIpModal = ({ onClose }) => {
  useSetZIndex(".cabinet", "999");

  const { cabinet: { orders: { residential: {
    newListModalTitle, proxyListName, listNamePlaceholder,
    authByIp, country, region, file, exportFormat,
    city, portsHint, sessionType,
    exportLink, exportLabel, format, listType, normalList,
    specialList, typeLink, cancel, createList, authorization,
    login, password, geo, isp
  } } } } = useTranslation();

  return (
    <CustomModal
      open={true}
      onClose={onClose}
      styles={{ zIndex: "999999999" }}
    >
      <div className="ip-list-modal">
        <div className="ip-list-modal__title">{newListModalTitle}</div>
        <div className=" ip-list-modal__block">
          <div className="ip-list-modal__label">{proxyListName}</div>
          <CustomInput label={listNamePlaceholder} />
        </div>
        <div className="ip-list-modal__block">
          <div className="ip-list-modal__label">{authorization}</div>
          <div className="ip-list-modal__wrapper ip-list-modal__auth-params">
            <div className="ip-list-modal__radio">
              <div className="ip-list-modal__radio-wrapper">
                <div className={classNames("ip-list-modal__radio-label", { "ip-list-modal__radio-label--active": true })}>{login}/{password}</div>
                <Radio isActive={true} />
              </div>
              <div className="ip-list-modal__radio-wrapper">
                <div className={classNames("ip-list-modal__radio-label", { "ip-list-modal__radio-label--active": false })}>{authByIp}</div>
                <Radio isActive={false} />
              </div>
            </div>
            <div className="ip-list-modal__credentials">
              <CustomInput label={login} icon="newCopy" />
              <CustomInput label={password} icon="newCopy" />
            </div>
          </div>
        </div>
        <div className="ip-list-modal__block">
          <div className="ip-list-modal__label">{geo}</div>
          <div className="ip-list-modal__wrapper ip-list-modal__geo-params">
            <CustomSelect placeholder={country} />
            <CustomSelect placeholder={region} />
            <CustomSelect placeholder={city} />
            <CustomSelect placeholder={isp} />
            <div>
              <CustomInput label="Ports" />
              <div className="ip-list-modal__hint">{portsHint}</div>
            </div>
          </div>
        </div>
        <div className="ip-list-modal__block">
          <div className="ip-list-modal__label">{sessionType}</div>
          <div className="ip-list-modal__session">
            <CustomSelect placeholder="Type" />
            <div className="ip-list-modal__session-text">
              Lorem ipsum dolor sit amet consectetur. Cras volutpat
              habitant sed tortor risus. Mauris eu mi amet tristique
              tempor egestas. Lorem ipsum dolor sit amet consectetur.
              Cras volutpat habitant sed
            </div>
          </div>
       </div>
        <div className="ip-list-modal__block">
          <div className="ip-list-modal__label">{exportFormat}</div>
          <div className="ip-list-modal__wrapper ip-list-modal__export">
            <div className="ip-list-modal__export-radio">
              <div className="ip-list-modal__radio-wrapper">
                <div className={classNames("ip-list-modal__radio-label", { "ip-list-modal__radio-label--active": false })}>{file}</div>
                <Radio isActive={false}/>
              </div>
              <div className="ip-list-modal__radio-wrapper">
                <div className={classNames("ip-list-modal__radio-label", { "ip-list-modal__radio-label--active": true })}>{exportLink}</div>
                <Radio isActive={true}/>
              </div>
            </div>
            <div className="ip-list-modal__export-fields">
              <CustomSelect placeholder={exportLabel} />
              <CustomInput label={format} />
            </div>
          </div>
        </div>
        <div className="ip-list-modal__block">
          <div className="ip-list-modal__label">{listType}</div>
          <div className="ip-list-modal__type">
            <div className="ip-list-modal__type-radio">
              <div className="ip-list-modal__radio-wrapper">
                <div className={classNames("ip-list-modal__radio-label", { "ip-list-modal__radio-label--active": true })}>{normalList}</div>
                <Radio isActive={true}/>
              </div>
              <div className="ip-list-modal__radio-wrapper">
                <div className={classNames("ip-list-modal__radio-label", { "ip-list-modal__radio-label--active": false })}>{specialList}</div>
                <Radio isActive={false}/>
              </div>
            </div>
            <div className="ip-list-modal__type-wrapper">
              <div className="ip-list-modal__type-text">
                Lorem ipsum dolor sit amet consectetur.
                Cras volutpat habitant sed tortor risus.
                Mauris eu mi amet tristique tempor egestas.
                Lorem ipsum dolor sit amet consectetur.
                Cras volutpat habitant sed
              </div>
              <div className="ip-list-modal__type-link">
                <div>{typeLink}</div>
                <IconSvg tag="newArrow" />
              </div>
            </div>
          </div>
        </div>
        <div className="ip-list-modal__actions">
          <Button>{cancel}</Button>
          <Button tab="confirm">{createList}</Button>
        </div>
      </div>
    </CustomModal>
  );
};
